
import TutorSidebar from '../../../TutorSidebar/TutorSidebar'
import { Link } from 'react-router-dom'
import TutorHeader from '../../../TutorHeader/TutorHeader'
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const TutorAddNewSessionGroup = () => {

    // State to store session data and unique ID counter
    const [sessions, setSessions] = useState([
        { id: 1, date: "", time: "", topic: "", hideAddButton: false },
    ]);
    const [sessionIdCounter, setSessionIdCounter] = useState(2); // Initialize with 2 since the first session ID is 1

    // Yup validation schema
    const validationSchema = Yup.object().shape({
        sessions: Yup.array().of(
            Yup.object().shape({
                date: Yup.string().required("Date is required"),
                time: Yup.string().required("Time is required"),
                topic: Yup.string().required("Topic details are required"),
            })
        ),
    });

    // Formik setup
    const formik = useFormik({
        initialValues: {
            sessions: sessions,
        },
        validationSchema,
        onSubmit: (values) => {

            alert("Sessions Submitted Successfully");
        },
        enableReinitialize: true, // Updates form values when state changes
    });

    // Function to add a new session
    const addSession = () => {
        const newSession = {
            id: sessionIdCounter, // Use the unique counter for ID
            date: "",
            time: "",
            topic: "",
            hideAddButton: false,
        };

        // Hide the "plus" button for the previous session
        const updatedSessions = sessions.map((session, index) => {
            if (index === sessions.length - 1) {
                return { ...session, hideAddButton: true };
            }
            return session;
        });

        const newSessionsList = [...updatedSessions, newSession];

        // Increment the session ID counter
        setSessionIdCounter(sessionIdCounter + 1);

        // Update both Formik values and local state
        setSessions(newSessionsList);
        formik.setFieldValue("sessions", newSessionsList);
    };

    // Function to delete a session
    const deleteSession = (id) => {
        const updatedSessions = sessions.filter((session) => session.id !== id);

        // Show the "plus" button for the last remaining session
        if (updatedSessions.length > 0) {
            updatedSessions[updatedSessions.length - 1].hideAddButton = false;
        }

        // Update both Formik values and local state
        setSessions(updatedSessions);
        formik.setFieldValue("sessions", updatedSessions);
    };



    return (
        <div className='tutor-module'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Create Group Course
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="add-new-course-sec">
                                        <h4 className="mb-4">Create New Session</h4>
                                        <div className="row my-3">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Select Your Local Time Slot
                                                    </label>
                                                    <br />
                                                    <select className="select-form">
                                                        <option value=''>-Select-</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Start Date (Assign Date)
                                                    </label>
                                                    <br />
                                                    <input type="date" className="input-card-form" />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        End Date (Submit Date)
                                                    </label>
                                                    <br />
                                                    <input type="date" className="input-card-form" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card bg-light">
                                            <div className="card-body">
                                                <div id="session-container">
                                                    {formik.values.sessions.map((session, index) => (
                                                        <div
                                                            key={session.id}
                                                            className="session mb-4"
                                                            id={`session-${session.id}`}
                                                        >
                                                            <div className="row">
                                                                <div className="col-lg-10">
                                                                    <h6 className="mb-3">Session-{index + 1}</h6>
                                                                </div>
                                                                <div className="col-lg-2 d-flex justify-content-end">
                                                                    {/* Hide delete button if only one session is remaining */}
                                                                    {formik.values.sessions.length > 1 && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger px-2 py-1 delete-session-btn"
                                                                            title="Delete"
                                                                            onClick={() => deleteSession(session.id)}
                                                                        >
                                                                            <i className="fa-solid fa-trash"></i>
                                                                        </button>
                                                                    )}
                                                                </div>

                                                                {/* Session Start Date */}
                                                                <div className="col-lg-6 col-md-6">
                                                                    <div className="input-group">
                                                                        <label className="label">Session Start Date*</label>
                                                                        <br />
                                                                        <input
                                                                            type="date"
                                                                            className="input-card-form"
                                                                            name={`sessions[${index}].date`}
                                                                            value={formik.values.sessions[index].date}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            required
                                                                        />
                                                                        {formik.touched.sessions &&
                                                                            formik.touched.sessions[index]?.date &&
                                                                            formik.errors.sessions &&
                                                                            formik.errors.sessions[index]?.date && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors.sessions[index].date}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>

                                                                {/* Session Start Time */}
                                                                <div className="col-lg-6 col-md-6">
                                                                    <div className="input-group">
                                                                        <label className="label">Session Start Time*</label>
                                                                        <br />
                                                                        <select
                                                                            className="select-form"
                                                                            name={`sessions[${index}].time`}
                                                                            value={formik.values.sessions[index].time}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            required
                                                                        >
                                                                            <option value="">-Select-</option>
                                                                            <option value="09:00 AM">09:00 AM</option>
                                                                            <option value="10:00 AM">10:00 AM</option>
                                                                            <option value="11:00 AM">11:00 AM</option>
                                                                        </select>
                                                                        {formik.touched.sessions &&
                                                                            formik.touched.sessions[index]?.time &&
                                                                            formik.errors.sessions &&
                                                                            formik.errors.sessions[index]?.time && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors.sessions[index].time}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>

                                                                {/* Enter Topic Details */}
                                                                <div className="col-lg-12">
                                                                    <div className="input-group">
                                                                        <label className="label">Enter Topic Details*</label>
                                                                        <br />
                                                                        <textarea
                                                                            className="input-card-form"
                                                                            name={`sessions[${index}].topic`}
                                                                            placeholder="Topic Details"
                                                                            value={formik.values.sessions[index].topic}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            required
                                                                        />
                                                                        {formik.touched.sessions &&
                                                                            formik.touched.sessions[index]?.topic &&
                                                                            formik.errors.sessions &&
                                                                            formik.errors.sessions[index]?.topic && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors.sessions[index].topic}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                    {/* Add Session Button at the End of Last Session */}
                                                    <div className="d-flex justify-content-end mt-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary px-2 py-1 add-session-btn"
                                                            onClick={addSession}
                                                        >
                                                            <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <h6 className="text-primary mb-0 mt-4">
                                            Total Session&nbsp;
                                            <p
                                                className="fw-bold btn btn-primary mb-0"
                                                style={{ borderRadius: "50%", fontSize: 12, padding: "5px 10px" }}
                                            >
                                                {formik.values.sessions.length}
                                            </p>
                                        </h6>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-12">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#addcourseModal"
                                                    className="btn btn-primary fw-bold w-100 mb-4 mt-2"
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </main>


                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Modal */}
                <div
                    className="modal fade"
                    id="addcourseModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body my-4">
                                <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                                <h4 style={{ width: "74%" }}>
                                    We will reach you after getting approval from{" "}
                                    <span className="text-primary">Admin</span>
                                </h4>
                                <Link to="/tutor/dashboard">
                                    <button type="button" data-bs-dismiss="modal" className="btn btn-primary mt-4 px-4 mb-5">
                                        Okay
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default TutorAddNewSessionGroup